/** @format */
import { CountryList } from '@toucan/common/services/fixtures/countries';

import { client } from '@toucan/client/global/axios';
import { MarketSlug } from '@toucan/client/global/market';

export async function getCountryList(slug: MarketSlug): Promise<CountryList> {
    const { data } = await client.get<CountryList>('/fixtures/countries', {
        headers: {
            'X-Market': slug.toLowerCase(),
        },
    });

    return data;
}
